/**
 * Created by stonewang on 2017/8/15.
 */
import React from 'react';
import Reflux from 'reflux';
import { Button } from 'antd';
import { hashHistory, withRouter } from 'react-router';
import { DmsTab, TableView, FilterBox } from 'Components';
import { list } from '../../service/store'
import { sKeylist } from '../../service/dictionary/dataitem';
import {Store, Actions} from './store';

class StoreList extends Reflux.Component {
  constructor (props) {
    super(props);

    this.dealerName = this.props.location.query.dealerName || '';
    this.belongDealer = this.props.location.query.belongDealer || null;

    this.store = Reflux.initStore(Store); //创建一个Store实例
    this.state = {
      filterBoxVisible: false,
      store_way: [],
      store_type: [],
      rows: [],
      total: 0,
      searchObj: {
        name: '',
        shopowner: '',
        active: null,
        operateWay: null,
        storeType: null,
        dealerName: this.dealerName,
        belongDealer:  this.belongDealer,
        s: 10,
        p: 1,
      }
    };
    this.getData = this.getData.bind(this);
    this.pageChange = this.pageChange.bind(this);
    this.visibleChange = this.visibleChange.bind(this);
    this.setFilterParam = this.setFilterParam.bind(this);
    this.advanceReset = this.advanceReset.bind(this);
    this.advanceSubmit = this.advanceSubmit.bind(this);
    this.routeLeaveHook = this.routeLeaveHook.bind(this);
  }
  //离开当前路由时，更新store
  routeLeaveHook(nextLocation) {
    let path = nextLocation.pathname.split('/');
    if(path[1] === 'store' && path[2] !== 'add'){ //当下一个路由是详情页时，将useStore的值设为true
      Actions.useStoreChange(true);
      Actions.paramChange(this.state.searchObj);
    }else{
      Actions.useStoreChange(false);
      Actions.paramChange({});
    }
  }

  componentWillMount () {
    const self = this;
    const data = this.store.state;
    if(data.useStore) { //根据useStore的值判断是否使用store中的数据
      this.setState({
        ...this.state,
        searchObj: {
          ...this.state.searchObj,
          ...data.params,
          dealerName: this.dealerName,
          belongDealer:  this.belongDealer,
        }
      });
    }
    sKeylist({ sKey: 'store_way' }).then(res => { //门店运营方式
      if (res.data && res.data.length > 0) {
        let arr = [{
          value: '',
          text: '全部'
        }];
        res.data.forEach(x => {
          arr.push({
            value: x.sKey,
            text: x.name
          });
        });
        let timer = window.setInterval(function () {
          if (self.mounted) {
            window.clearInterval(timer);
            self.setState({ store_way: arr })
          }
        }, 0);
      }
    });
    sKeylist({ sKey: 'store_type' }).then(res => { //门店类型
      if (res.data && res.data.length > 0) {
        let arr = [{
          value: '',
          text: '全部'
        }];
        res.data.forEach(x => {
          arr.push({
            value: x.sKey,
            text: x.name
          });
        });

        let timer = window.setInterval(function () {
          if (self.mounted) {
            window.clearInterval(timer);
            self.setState({ store_type: arr });
          }
        }, 0);
      }
    })
  }

  componentDidMount () {
    this.mounted = true;
    this.getData();
    //设置离开当前路由时的钩子函数
    this.props.router.setRouteLeaveHook(this.props.route, this.routeLeaveHook);
  }

  goView (url) {
    hashHistory.push(url);
  }

  visibleChange () {
    this.setState({ filterBoxVisible: !this.state.filterBoxVisible });
  }

  advanceReset () {
    const self = this;
    this.setState({
      filterBoxVisible: false,
      searchObj: {
        ...this.state.searchObj,
        name: '',
        shopowner: '',
        active: null,
        operateWay: null,
        storeType: null,
        dealerName: this.dealerName || '',
        //belongDealer: this.belongDealer || '',
        p: 1,
      }
    }, () => {
      self.getData();
    })
  };

  advanceSubmit (form) {
    const self = this;
    this.setState({
      filterBoxVisible: false,
      searchObj: { ...this.state.searchObj, p: 1 }
    }, function () {
      self.getData();
    });
  };

  setFilterParam (name, value) {
    // console.log(name + ':\t' + value);
    if (name === 'lastOperationTime') {
      this.setState({
        searchObj: {
          ...this.state.searchObj,
          lastOperationTimeStart: value.from,
          lastOperationTimeEnd: value.end
        }
      })
    } else {
      this.setState({ searchObj: { ...this.state.searchObj, [name]: value } })
    }
  };

  pageChange (page, pageSize) {
    const self = this;
    this.setState({ searchObj: { ...this.state.searchObj, s: pageSize, p: page } }, function () {
      self.getData();
    });
  }

  getData () {
    const self = this;
    const { searchObj } = this.state;
    list(searchObj).then(res => {
      if (res.status) {
        self.setState({ total: res.total, rows: res.data });
      } else {
        console.error(res.message);
      }
    });
  }

  backTo () {
    window.history.go(-1);
  }

  render () {
    const { filterBoxVisible, rows, total, searchObj, store_way, store_type } = this.state;
    const filterBoxProps = {
      showFlag: filterBoxVisible,
      advance: {
        fileds: [
          {
            name: 'name',
            label: '名称',
            text: '输入门店名称',
            defaultValue: searchObj.name,
            type: 'default'
          },
          {
            name: 'shopowner',
            label: '店长',
            text: '输入店长姓名',
            defaultValue: searchObj.shopowner,
            type: 'default'
          },
          {
            name: 'active',
            label: '门店状态',
            text: '选择状态',
            dataType: 'number',
            defaultValue: searchObj.active !== null ? searchObj.active+'' : 'null',
            options: [
              { value: null, text: '全部' },
              { value: 0, text: '已停运' },
              { value: 1, text: '运营中' },
            ],
            multiple: false,//支持多选
            type: 'select'
          },
          {
            name: 'operateWay',
            label: '运营方式',
            text: '选择运营方式',
            defaultValue: searchObj.operateWay,
            options: store_way,
            multiple: false,//支持多选
            type: 'select'
          },
          {
            name: 'storeType',
            label: '类型',
            text: '选择类型',
            defaultValue: searchObj.storeType,
            options: store_type,
            multiple: false,//支持多选
            type: 'select'
          },
          {
            name: 'dealerName',
            label: '所属经销商',
            text: '输入所属经销商',
            defaultValue: this.dealerName,
            type: 'default'
          }
        ],
        handle: this.advanceSubmit,
        reset: this.advanceReset,
        fieldHandle: this.setFilterParam
      }
    };
    const tableViewProps = {
      loading: false,//更新表格数据中
      rowKey: 'id',
      pageParam: {
        total,
        current: searchObj.p,//当前页码
        pageSize: searchObj.s,//当前分页数
        onChange: this.pageChange
      },
      columns: [
        {
          title: '名称',
          dataIndex: 'name',
          render: (text, record, index) => {
            return <a href={`#/store/${record.id}`}>{text}</a>
          }
        }, {
          title: '地址',
          dataIndex: 'storeAddress',
          render: (text, record, index) => {
            return <div className="bu_s_h">{`${record.provinceText || ''}${record.cityText || ''}${record.countyText || ''}${text || ''}`}</div>;
          }
        }, {
          title: '店长',
          dataIndex: 'shopowner'
        }, {
          title: '运营方式',
          dataIndex: 'operateWayText',
        }, {
          title: '类型',
          dataIndex: 'storeTypeText',
        }, {
          title: '员工总数',
          dataIndex: 'storeEmployeeNum'
        }, {
          title: '所属经销商',
          dataIndex: 'dealerName'
        }, {
          title: '状态',
          dataIndex: 'active',
          render: (text, record, index) => {
            if (text === 0) return '已停运';
            if (text === 1) return '运营中';
            return '';
          }
        }
      ],
      rows
    };
    let self = this;
    let backHide = (belongDealer) => {
      if (belongDealer) {
        return <Button onClick={self.backTo.bind(self)}>返回</Button>
      } else {
        return '';
      }
    }
    return <div className="dms-body">
      <DmsTab options={['门店列表']} defaultKey={0}>
        {backHide(this.belongDealer)}
        <Button icon="plus" onClick={this.goView.bind(this, `/store/add/0?belongDealer=${this.belongDealer||''}`)}>新增</Button>
        <Button icon="filter" onClick={this.visibleChange}>筛选</Button>
        <FilterBox  {...filterBoxProps}/>
      </DmsTab>
      <div className="dms-table-box">
        <TableView {...tableViewProps}/>
      </div>
    </div>
  }
}
//使用高阶组件withRouter来封装StoreList。目的是将router对象暴露出来
export default withRouter(StoreList);


// WEBPACK FOOTER //
// ./src/routes/store/list.js